export async function uploadProductImages(productName, files) {
    const fd = new FormData();
    fd.append("productName", productName);

    // multi
    for (const f of files) fd.append("files[]", f);

    const res = await fetch("http://localhost/upls/imagePG.php", {
        method: "POST",
        body: fd,
    });

    const data = await res.json();
    if (!res.ok) throw new Error(data?.error || "Upload failed");

    // επιστρέφει array από urls
    return data.urls ?? [];
}
